import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint } = theme

export const Featured = styled.div`
  padding-bottom: ${space.xl3};

  @media (min-width: ${breakpoint.lg}) {
    padding: ${space.lg} 0 ${space.xl5};
  }
`

export const MainFeatured = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: ${breakpoint.lg}) {
    padding-top: ${space.xl};

    & .longText {
      width: 70%;
      text-align: center;
    }
  }
`
